import { getFormattedDateTimev2 } from "utils";

export const getCombinedShipmentFteid = (
  createdBy = "",
  invoiceNumber = "",
) => {
  const creator = createdBy?.trim() || "";
  const invoice = invoiceNumber?.trim() || "";
  return `${creator}-${invoice}`;
};

export const buildCreateShipmentPayload = (formData) => {
  if (!formData) return {};

  const combinedFteid = getCombinedShipmentFteid(
    formData.createdBy,
    formData.invoiceNumber,
  );

  return {
    shipmentFteid: combinedFteid,
    plannedDispatchDate: getFormattedDateTimev2(formData.plannedDispatchDate),
    deliveryType: formData.deliveryType || "JOTS",
    modeOfShipment: formData.modeOfShipment || "Road",
    dispatchOrders: (formData.dispatchOrders || [])
      .map((order) => ({
        doId: order.doId || "",
        lineItems: (order.lineItems || [])
          .filter((item) => {
            const qtyStr = String(item.quantity ?? "").trim();
            return (
              qtyStr !== "" && !isNaN(Number(qtyStr)) && Number(qtyStr) > 0
            );
          })
          .map((item) => ({
            lineItemNumber: item.lineItemNumber || "",
            materialMasterId: item.materialMasterId || "",
            quantity: item.quantity,
          })),
      }))
      .filter((order) => order.lineItems.length > 0),
    addressPickupAndDrop: {
      pickup: {
        address: formData.addressPickupAndDrop?.pickup?.address || "",
        city: formData.addressPickupAndDrop?.pickup?.city || "",
        state: formData.addressPickupAndDrop?.pickup?.state || "",
        postalCode: formData.addressPickupAndDrop?.pickup?.postalCode || "",
      },
      drop: {
        address: formData.addressPickupAndDrop?.drop?.address || "",
        city: formData.addressPickupAndDrop?.drop?.city || "",
        state: formData.addressPickupAndDrop?.drop?.state || "",
        postalCode: formData.addressPickupAndDrop?.drop?.postalCode || "",
      },
    },
    deliveryTimeWindow: {
      start: getFormattedDateTimev2(formData.deliveryTimeWindow?.start),
      end: getFormattedDateTimev2(formData.deliveryTimeWindow?.end),
    },
    ETA: getFormattedDateTimev2(formData.ETA),
    ftStatus: formData.ftStatus || "Planned",
    salesFreightValue: Number(formData.salesFreightValue) || 0,
    salesFreightUOM: formData.salesFreightUOM || "INR",
    deliveryInstruction: formData.createdBy || "",
  };
};

export const validateShipmentForm = (formData) => {
  const errors = [];

  if (!formData.createdBy?.trim()) {
    errors.push("Created By (User Email) is required");
  }
  if (!formData.invoiceNumber?.trim()) {
    errors.push("Invoice Number is required");
  }
  if (!formData.plannedDispatchDate) {
    errors.push("Planned Dispatch Date & Time is required");
  }
  if (!formData.deliveryTimeWindow?.start) {
    errors.push("Delivery Time Window Start is required");
  }
  if (!formData.deliveryTimeWindow?.end) {
    errors.push("Delivery Time Window End is required");
  }
  if (!formData.ETA) {
    errors.push("ETA is required");
  }
  if (!formData.addressPickupAndDrop?.drop?.city?.trim()) {
    errors.push("Drop City is required");
  }

  // Dispatch orders & quantities
  if (!formData.dispatchOrders?.length) {
    errors.push("At least one Dispatch Order is required");
  } else {
    formData.dispatchOrders.forEach((order, doIdx) => {
      const doLabel = order.doId
        ? `DO ${order.doId}`
        : `Dispatch Order ${doIdx + 1}`;

      const lineItems = order.lineItems || [];
      const itemsWithQty = lineItems.filter((item) => {
        const qtyStr = String(item.quantity ?? "").trim();
        return qtyStr !== "";
      });

      if (itemsWithQty.length === 0) {
        errors.push(
          `${doLabel}: At least one Line Item must have a quantity entered`,
        );
      } else {
        lineItems.forEach((item, itemIdx) => {
          const qtyStr = String(item.quantity ?? "").trim();
          if (!qtyStr) return;

          const qtyNum = Number(qtyStr);
          if (isNaN(qtyNum) || qtyNum <= 0) {
            errors.push(
              `${doLabel}, Line Item ${
                itemIdx + 1
              }: Quantity must be a valid number greater than 0`,
            );
          } else if (
            item.maxAllowedQty &&
            qtyNum > Number(item.maxAllowedQty)
          ) {
            errors.push(
              `${doLabel}, Line Item ${
                itemIdx + 1
              }: Quantity cannot exceed allowed quantity of ${
                item.maxAllowedQty
              }`,
            );
          }
        });
      }
    });
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
